import { sortArrayOfObjects } from "@/components/Buy/commonFn";

export interface ICartLayoutConfig {
  desktop: IComponentConfig[];
  mobile: IComponentConfig[];
}

export interface IComponentConfig {
  name: string;
  path: string;
  column: number;
  position: number;
  stepOrder?: number;
}

export enum layoutItemNames {
  cart = "cart",
  accountCredit = "accountCredit",
  vat = "vat",
  promoCode = "promoCode",
  candyRack = "candyRack",
  phoneAssistance = "phoneAssistance",
  email = "email",
  paymentOptions = "paymentOptions",
  shippingAddress = "shippingAddress",
  cardDetails = "cardDetails",
  reviewOrder = "reviewOrder",
  paymentAddress = "paymentAddress",
}

export const stepOrder: IComponentConfig[] = [
  {
    name: "email",
    path: "emailLoader",
    column: 1,
    position: 6,
    stepOrder: 1,
  },
  {
    name: "paymentAddress",
    path: "paymentAddressLoader",
    column: 1,
    position: 7,
    stepOrder: 2,
  },
  {
    name: "shippingAddress",
    path: "shippingAddressLoader",
    column: 1,
    position: 8,
    stepOrder: 3,
  },
  {
    name: "cardDetails",
    path: "cardDetailsLoader",
    column: 1,
    position: 8,
    stepOrder: 4,
  },
  {
    name: "reviewOrder",
    path: "reviewOrder",
    column: 1,
    position: 10,
    stepOrder: 5,
  },
];

export const config: ICartLayoutConfig = {
  desktop: [
    //Column 1
    {
      name: "cart",
      path: "cartLoader",
      column: 1,
      position: 1,
    },
    {
      name: "accountCredit",
      path: "accountCreditEarned",
      column: 1,
      position: 2,
    },
    {
      name: "vat",
      path: "vatInput",
      column: 1,
      position: 3,
    },
    {
      name: "promoCode",
      path: "promoCode",
      column: 1,
      position: 4,
    },
    {
      name: "candyRack",
      path: "specialOffersLoader",
      column: 1,
      position: 5,
    },
    //Column 2
    {
      name: "email",
      path: "emailLoader",
      column: 2,
      position: 1,
      stepOrder: 1,
    },
    {
      name: "paymentOptions",
      path: "paymentLoader",
      column: 2,
      position: 2,
      stepOrder: 2,
    },
    {
      name: "paymentAddress",
      path: "paymentAddressLoader",
      column: 2,
      position: 3,
      stepOrder: 3,
    },
    {
      name: "shippingAddress",
      path: "shippingAddressLoader",
      column: 2,
      position: 4,
      stepOrder: 4,
    },
    {
      name: "cardDetails",
      path: "cardDetailsLoader",
      column: 2,
      position: 5,
      stepOrder: 5,
    },
    {
      name: "reviewOrder",
      path: "reviewOrder",
      column: 2,
      position: 6,
      stepOrder: 6,
    },
  ],
  mobile: [
    //Column 1
    {
      name: "cart",
      path: "cartLoader",
      column: 1,
      position: 1,
    },
    {
      name: "accountCredit",
      path: "accountCreditEarned",
      column: 1,
      position: 2,
    },
    {
      name: "vat",
      path: "vatInput",
      column: 1,
      position: 3,
    },
    {
      name: "promoCode",
      path: "promoCode",
      column: 1,
      position: 4,
    },
    {
      name: "candyRack",
      path: "specialOffersLoader",
      column: 1,
      position: 5,
    },
    {
      name: "email",
      path: "emailLoader",
      column: 1,
      position: 6,
      stepOrder: 1,
    },
    {
      name: "paymentOptions",
      path: "paymentLoader",
      column: 1,
      position: 9,
      stepOrder: 2,
    },
    {
      name: "paymentAddress",
      path: "paymentAddressLoader",
      column: 1,
      position: 7,
      stepOrder: 3,
    },
    {
      name: "shippingAddress",
      path: "shippingAddressLoader",
      column: 1,
      position: 8,
      stepOrder: 4,
    },
    {
      name: "reviewOrder",
      path: "reviewOrder",
      column: 1,
      position: 10,
      stepOrder: 5,
    },
  ],
};

export function getNumberOfColumns(items: IComponentConfig[]) {
  return sortArrayOfObjects(items, "column", "descending")[0].column;
}

export function sortLayoutByColumnAndPosition(items: IComponentConfig[]) {
  const sortedItems: IComponentConfig[] = [];

  //Figure out number of columns by reverse sort and getting the first one
  const numberOfColumns = getNumberOfColumns(items);

  for (let column = 1; column <= numberOfColumns; column++) {
    const group = items.filter(l => l.column === column);
    if (group) {
      const sorted = sortArrayOfObjects(group, "position", "ascending");
      sortedItems.push(...sorted);
    }
  }

  return sortedItems;
}
